import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingContact from '../components/FloatingContact';

const PublicLayout = () => (
  <div className="min-h-screen bg-white flex flex-col">
    <Header />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <FloatingContact />
  </div>
);

export default PublicLayout;
